import {
    parseLocationResponse,
    collections as collectionsDuck,
} from '@eb/destination-utils';
import { deepKeysToCamel } from '@eb/transformation-utils';

import { retrieveHomeFeedState } from '../utils/sessionStorage';
import { getSeasonalContent } from '../utils/seasonal';
import { getHeaderContent } from '../utils/background';

import { transformBucketsContent } from '../utils/transformation';
import { getFiveToFollowContent } from '../utils/content';
import { getHeroImageIndex } from '../utils/localStorage';

const {
    utils: { transformCollectionResponse },
} = collectionsDuck;

export const transformFiveToFollowResponse = (fiveToFollow) =>
    fiveToFollow && deepKeysToCamel(fiveToFollow);

export const getInitialState = (props) => {
    const {
        buckets,
        experiments,
        featureFlags,
        gaSettings,
        locationSlug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        placeType,
        locations,
        userCollections,
        flatBucket,
        isOnline,
        isBotRequest,
        env,
        facebookOptions,
        user: { isAuthenticated, publicId, canCreateEvents },
    } = props;

    const {
        currencyFormat,
        ebDomain: domain,
        isMobile,
        localeInfo: {
            // every locale can use a different twitter account and
            // facebook account, so we need to use them in order to build
            // share messages
            twitter_handle: twitterHandle,
            facebook_locale: facebookLocale,
            facebook_page: facebookPage,
            tld,
            locale,
        },
        serverUrl,
    } = env;
    const seasonalContent = getSeasonalContent({ placeId, tld });
    const browseState = retrieveHomeFeedState({ seasonalContent });
    const { entities, entityContext } = transformBucketsContent(buckets);
    const fiveToFollowContent = getFiveToFollowContent(placeId);
    const organizersUserFollow = [];

    let _header;

    /**
     * We only get the header content when we have the full context loaded
     * to prevent double rendering and getting two images without reason.
     */
    if (currentPlace || placeId || latitude) {
        _header = getHeaderContent({ seasonalContent, tld });
    }

    return {
        currencyFormat,
        gaSettings,
        app: {
            domain,
            tld,
            locale,
            experiments,
            featureFlags,
            isMobile,
            loadingState: {
                isFeLoading: true,
                isSearchLoading: false,
                isCityBrowseLoading: false,
                isProfilesLoading: false,
                isOrganizerArticlesLoading: false,
            },
            isBotRequest,
        },
        env,
        content: {
            entities,
            entityContext,
            flatBucket,
            browseState,
            seasonal: seasonalContent,
        },
        collections: transformCollectionResponse(userCollections),
        fiveToFollow: transformFiveToFollowResponse(fiveToFollowContent),
        organizers: {
            organizersUserFollow,
        },
        location: {
            slug: locationSlug,
            placeId,
            latitude,
            longitude,
            currentPlace,
            currentPlaceParent,
            placeType,
            topSuggestions: locations ? parseLocationResponse(locations) : [],
            isOnline,
        },
        search: {
            slug: locationSlug,
            placeId,
            latitude,
            longitude,
            currentPlace,
            currentPlaceParent,
            placeType,
            topSuggestions: locations ? parseLocationResponse(locations) : [],
        },
        user: {
            isAuthenticated,
            publicId,
            canCreateEvents,
        },
        shareOptions: {
            isMobile,
            twitterHandle,
            serverUrl,
            facebookOptions: {
                ...facebookOptions,
                locale: facebookLocale,
                page: facebookPage,
            },
        },
        header: _header,
        headerImageIndex: getHeroImageIndex(),
    };
};
